import React, { PropTypes } from 'react';
import { withRouter } from 'react-router';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { shelfShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { DropdownMenuDivider, DropdownMenuHeader, DropdownMenuItem } from '@bibliocommons/base-dropdown';

import { SHELF_NAMES } from '../../../constants/ShelfConstants';
import BatchActionsListContainer from '../../../containers/shared/BatchActions/BatchActionsListContainer';
import BatchActionsListItem from '../../shared/BatchActions/BatchActionsListItem';
import ItemList from '../../shared/ItemList';
import ShelfListItem from '../ShelfListItem';

export class ShelfList extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleBatchRemove', 'handleBatchMove', 'renderBatchActionsMenu');
  }

  renderBibList() {
    const items = this.props.shelf.get('items');

    return (
      <ItemList>
        {items.map(item => this.renderShelfListItem(item))}
      </ItemList>
    );
  }

  renderBatchActionsList() {
    const { shelf, shelfTransactions } = this.props;
    const items = shelf.get('items');
    const pageNumber = shelf.getIn(['pagination', 'page']);
    const pageLimit = shelf.getIn(['pagination', 'limit']);
    const totalCount = shelf.getIn(['pagination', 'count']);

    const actionIsLoading = shelfTransactions.toList().some(item =>
      item.get('isBatchRemoving') || item.get('isBatchMoving')
    );

    return (
      <BatchActionsListContainer
        list={items}
        actionIsLoading={actionIsLoading}
        pageNumber={pageNumber}
        pageLimit={pageLimit}
        totalItems={totalCount}
        renderActionsMenu={this.renderBatchActionsMenu}>
        {(selectedActionItems, updateItem) => (
          <ItemList>
            {items.map((item) => this.renderBatchActionsListItem(item, selectedActionItems, updateItem))}
          </ItemList>
        )}
      </BatchActionsListContainer>
    );
  }

  renderBatchActionsListItem(item, selectedActionItems, updateItem) {
    return (
      <BatchActionsListItem key={`batch-actions-list-item-${item.get('id')}`} actionItem={item} selectedItems={selectedActionItems} updateItem={updateItem}>
        {this.renderShelfListItem(item)}
      </BatchActionsListItem>
    );
  }

  // used to trim down list of bibs related for each similar titles component
  getBibsForSimilarTitles(ownerSimilarTitles, metadataId) {
    return this.props.bibs.filter(item =>
      ownerSimilarTitles.get(metadataId, []).some(similarTitle =>
        item.get('id') === similarTitle.get('similarMetadataId')
      )
    );
  }

  renderShelfListItem(item) {
    const {
      availabilityDetailActions,
      commentsActions,
      quotationsActions,
      ratingsActions,
      tagsActions,
      shelfActions,
      tagsTransactions,
      videosActions,
      iOwnThisActions,
      similarTitlesActions,
      shelfTransactions,
      privateNotesActions,
      bibs,
      shelf,
      owner,
      ownerComments,
      ownerQuotations,
      ownerRatings,
      ownerTags,
      ownerVideos,
      ownerSimilarTitles,
      ownerPrivateNotes,
      iOwnThisSettings,
      currentLibrary,
      localBranch,
      commentsTransactions,
      quotationsTransactions,
      ratingsTransactions,
      videosTransactions,
      iOwnThisTransactions,
      similarTitlesTransactions,
      privateNotesTransactions,
      currentUserShelves
    } = this.props;

    const metadataId = item.get('metadataId');

    return (
      <ShelfListItem
        key={`shelf-list-item-${item.get('id')}`}
        item={item}
        owner={owner}
        shelfName={shelf.get('name')}
        bib={bibs.get(metadataId)}
        currentLibrary={currentLibrary}
        localBranch={localBranch}
        currentUserShelfItemForBib={currentUserShelves.get(metadataId)}
        ownerCommentForBib={ownerComments.get(metadataId)}
        ownerQuotationsForBib={ownerQuotations.get(metadataId)}
        ownerRatingForBib={ownerRatings.get(metadataId)}
        ownerTagsForBib={ownerTags.get(metadataId)}
        ownerVideoForBib={ownerVideos.get(metadataId)}
        ownerSettingForBib={iOwnThisSettings.get(metadataId)}
        ownerSimilarTitlesForBib={ownerSimilarTitles.get(metadataId)}
        ownerPrivateNoteForBib={ownerPrivateNotes.get(metadataId)}
        similarTitleBibs={this.getBibsForSimilarTitles(ownerSimilarTitles, metadataId)}
        commentsTransactions={commentsTransactions}
        quotationsTransactions={quotationsTransactions}
        ratingsTransactions={ratingsTransactions}
        tagsTransactions={tagsTransactions}
        videosTransactions={videosTransactions}
        iOwnThisTransactions={iOwnThisTransactions}
        similarTitlesTransactions={similarTitlesTransactions}
        privateNotesTransactions={privateNotesTransactions}
        shelfTransactions={shelfTransactions}
        availabilityDetailActions={availabilityDetailActions}
        commentsActions={commentsActions}
        quotationsActions={quotationsActions}
        ratingsActions={ratingsActions}
        tagsActions={tagsActions}
        videosActions={videosActions}
        similarTitlesActions={similarTitlesActions}
        iOwnThisActions={iOwnThisActions}
        privateNotesActions={privateNotesActions}
        shelfActions={shelfActions} />
    );
  }

  renderBatchActionsMenu(selectedActionItems) {
    const { shelf } = this.props;
    const selectedCount = selectedActionItems.size;

    const moveMenuHeader = (
      <DropdownMenuHeader key="shelf-batch-actions-header">
        <FormattedHTMLMessage id="change_shelf_location" />
      </DropdownMenuHeader>
    );

    const shelfNamesForMove = Immutable.Map(SHELF_NAMES).valueSeq().toArray().filter(shelfName => shelfName !== shelf.get('name'));
    const moveMenuItems = shelfNamesForMove.map(shelfName => (
      <DropdownMenuItem key={`shelf-batch-actions-menu-item-move-${shelfName}`}>
        <a href="#shelf-batch-move" onClick={(e) => this.handleBatchMove(e, shelfName, selectedActionItems)}>
          <FormattedMessage id={`label_shelf_${shelfName}`} />  ({selectedCount})
        </a>
      </DropdownMenuItem>
    ));

    const menuDivider = (
      <DropdownMenuDivider key="shelf-batch-actions-divider" />
    );

    const removeMenuItem = (
      <DropdownMenuItem key="shelf-batch-actions-menu-item-remove">
        <a href="#shelf-batch-remove" onClick={(e) => this.handleBatchRemove(e, selectedActionItems)}>
          <FormattedMessage id="button_remove_from_shelves" /> ({selectedCount})
        </a>
      </DropdownMenuItem>
    );

    return [
      moveMenuHeader,
      ...moveMenuItems,
      menuDivider,
      removeMenuItem
    ];
  }

  handleBatchRemove(e, selectedActionItems) {
    e.preventDefault();

    const shelfName = this.props.shelf.get('name');
    const selectedItems = selectedActionItems.toList();
    const shelfItemIds = selectedItems.map(item => item.get('id'));
    const metadataIds = selectedItems.map(item => item.get('metadataId'));
    this.props.shelfActions.removeShelfItems({
      shelfName,
      shelfItemIds,
      metadataIds,
      isBatch: true,
      postSuccess: () => {
        const { location, owner, shelfActions } = this.props;
        shelfActions.searchUserShelf(shelfName, owner.get('id'), { ...location.query, page: undefined });
      }
    });
  }

  handleBatchMove(e, newShelfName, selectedActionItems) {
    e.preventDefault();

    const shelfName = this.props.shelf.get('name');
    const selectedItems = selectedActionItems.toList();
    const shelfItemIds = selectedItems.map(item => item.get('id'));
    const metadataIds = selectedItems.map(item => item.get('metadataId'));
    this.props.shelfActions.updateShelfItems({
      shelfName,
      newShelfName,
      shelfItemIds,
      metadataIds,
      isBatch: true,
      postSuccess: () => {
        const { location, owner, shelfActions } = this.props;
        shelfActions.searchUserShelf(shelfName, owner.get('id'), { ...location.query, page: undefined });
      }
    });
  }

  render() {
    const { owner } = this.props;

    return (
      <div className="cp-shelf-list">
        {owner.get('loggedIn') ? this.renderBatchActionsList() : this.renderBibList()}
      </div>
    );
  }
}

ShelfList.propTypes = {
  currentLibrary: ImmutablePropTypes.map.isRequired,
  owner: userIdentityShape.isRequired,
  shelf: shelfShape.isRequired,
  localBranch: PropTypes.string,
  bibs: ImmutablePropTypes.map.isRequired,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  ratingsTransactions: ImmutablePropTypes.map.isRequired,
  tagsTransactions: ImmutablePropTypes.map.isRequired,
  videosTransactions: ImmutablePropTypes.map.isRequired,
  iOwnThisTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  similarTitlesTransactions: ImmutablePropTypes.map.isRequired,
  privateNotesTransactions: ImmutablePropTypes.map.isRequired,
  ownerComments: ImmutablePropTypes.map.isRequired,
  ownerQuotations: ImmutablePropTypes.map.isRequired,
  ownerRatings: ImmutablePropTypes.map.isRequired,
  ownerTags: ImmutablePropTypes.map.isRequired,
  ownerVideos: ImmutablePropTypes.map.isRequired,
  ownerSimilarTitles: ImmutablePropTypes.map.isRequired,
  ownerPrivateNotes: ImmutablePropTypes.map.isRequired,
  iOwnThisSettings: ImmutablePropTypes.map.isRequired,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ratingsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  videosActions: PropTypes.objectOf(PropTypes.func).isRequired,
  iOwnThisActions: PropTypes.objectOf(PropTypes.func).isRequired,
  similarTitlesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  privateNotesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  workflowActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentUserShelves: ImmutablePropTypes.map.isRequired
};

export default withRouter(ShelfList);



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfList/ShelfList.jsx